import { render } from "./AboutSitePage.vue?vue&type=template&id=7ddd024b&scoped=true"
import script from "./AboutSitePage.vue?vue&type=script&lang=js"
export * from "./AboutSitePage.vue?vue&type=script&lang=js"

import "./AboutSitePage.vue?vue&type=style&index=0&id=7ddd024b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddd024b"]])

export default __exports__